import React from 'react'
import './Home.css'
import { Container } from 'react-bootstrap'
const AboutHome = () => {
  return (
    <section className="_emtabout corp-hidden">
   <Container>
   <div className="_ininety">
      <div className="_Genttl">
        <span>
          {/*Search Flights, Hotels, Bus and Holiday Packages*/}Search Flights,
          Hotels, Bus and Holiday Packages
        </span>
      </div>
      <div className="_abt_txt">
        {/*EaseMyTrip is one of the largest online travel platforms in India, and a trusted name in the Indian travel industry. We offer "end to end" travel solutions including air tickets, hotel booking, cab and bus booking, train tickets and holiday packages. Additionally, we offer ancillary value-added services.*/}
        Innovate Blues is one of the fastest-growing online travel platforms in India, and a trusted name among modern-day travelers. We provide comprehensive "end-to-end" travel solutions including flight bookings, hotel reservations, cab and bus services, train tickets, and curated holiday packages. On top of that, we offer a variety of add-on services to enhance your travel experience.
      </div>
      <div className="_abt_txt">
      We know that organizing a trip can be time-consuming and stressful, so Innovate Blues is designed to simplify your journey from start to finish. Our intuitive platform offers a wide range of options tailored to your preferences. Whether you're heading out on a family holiday, an adventurous solo trip, or a business visit, Innovate Blues has everything you need under one roof. From flights and stays to car rentals and holiday bundles, we help you plan your entire trip seamlessly.
      </div>
      <div className="_abt_txt">
        {/*We believe in transparency and honesty in all our dealings. We do not charge any hidden fees, and our prices are always competitive. With EaseMyTrip, you can be assured of getting the best travel deals in the market. If you're looking for a hassle-free and affordable way to plan your next trip, look no further than EaseMyTrip. We promise to make your travel experience a memorable one.*/}
        At Innovate Blues, transparency and customer satisfaction are at the heart of what we do. There are no hidden charges—our pricing is upfront and competitive. With Innovate Blues, you can rest assured that you’re getting the best travel deals available. So if you're searching for a reliable, affordable, and hassle-free way to book your next getaway, choose Innovate Blues. Let us make your travel journey smooth, simple, and unforgettable.
      </div>
    </div>
   </Container>
  </section>
  
  )
}

export default AboutHome